"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheArtOfTheCrush() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section data-section-id="263581" id="the-art-of-the-crush" className="bg-background text-foreground py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-12 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="lg:col-span-6 lg:col-start-1 flex flex-col justify-center">
            <div className="mb-6 md:mb-8">
              <span className="text-secondary font-semibold tracking-widest text-sm md:text-base block mb-4 font-default">
                STAGE 01
              </span>
              <h2 className="font-default text-5xl md:text-7xl lg:text-8xl xl:text-[100px] font-medium leading-[1.05] tracking-tight text-primary">
                The <br className="hidden sm:block" />
                Harvest
              </h2>
            </div>
            
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl font-sans">
              At the peak of ripeness, our artisans hand-select each cluster from the sun-drenched slopes of Velvet Vineyards. This initial crush captures the pure essence of the terroir, ensuring only the most vibrant grapes begin the journey from vine to your glass.
            </p>
          </div>

          {}
          <div className="lg:col-span-5 lg:col-start-8">
            <div className="relative aspect-square md:aspect-[4/3] lg:aspect-[3/4] rounded-lg overflow-hidden shadow-xl bg-muted border-4 border-accent">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/grapes_and_vines.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/grapes_and_vines.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/grapes_and_vines.png-wvc-sizes" alt="Hand-harvesting grapes at Velvet Vineyards" className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-primary/5 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}